
import React, { useState, useEffect } from 'react';
import { subscribeToPopups } from '../utils/popupService';
import './Popup.css';

const Popup = () => {
    const [popup, setPopup] = useState(null);

    useEffect(() => {
        const unsubscribe = subscribeToPopups((newPopup) => {
            setPopup(newPopup);
        });

        return unsubscribe;
    }, []);

    if (!popup) return null;

    const { 
        type = 'info', 
        title, 
        message, 
        buttons = ['OK'], 
        onConfirm, 
        onCancel,
        forceAction = false 
    } = popup;

    const handleClose = () => {
        setPopup(null);
        if (onCancel) onCancel();
    };

    const handleBackdropClick = (e) => {
        if (e.target.className === 'popup-backdrop' && !forceAction && type !== 'warning') {
            handleClose();
        }
    };

    const renderButtons = () => {
        return buttons.map((btn, index) => {
            const isObject = typeof btn === 'object';
            const label = isObject ? btn.label : btn;
            const isSecondary = label.toLowerCase() === 'cancel' || label.toLowerCase() === 'no' || btn.variant === 'ghost' || btn.variant === 'secondary';
            const isDanger = label.toLowerCase() === 'delete' || btn.variant === 'danger';
            
            const handleClick = () => {
                setPopup(null);
                if (isObject && btn.onClick) {
                    btn.onClick();
                } else if (isSecondary) {
                    // "No" and "Cancel" are both secondary — never call onConfirm
                    if (onCancel) onCancel();
                } else {
                    if (onConfirm) onConfirm();
                }
            };

            let btnClass = 'popup-btn';
            if (isSecondary) btnClass += ' popup-btn-secondary';
            else if (isDanger) btnClass += ' popup-btn-danger';
            else btnClass += ' popup-btn-primary';

            return (
                <button 
                    key={index} 
                    className={btnClass}
                    onClick={handleClick}
                >
                    {label}
                </button>
            );
        });
    };

    return (
        <div className="popup-backdrop" onClick={handleBackdropClick}>
            <div className={`popup-card popup-type-${type}`}>
                <h2 className="popup-title">{title}</h2>
                <div className="popup-content">
                    <p className="popup-message">{message}</p>
                </div>
                <div className="popup-actions">
                    {renderButtons()}
                </div>
            </div>
        </div>
    );
};

export default Popup;
